export const getters = {
    getById: (state) => (id) => state.list.find((item) => Number(item.id) === Number(id)),
};
